<section class="tournament-group sb-card-shell">
  <div
    class="tournament-group__table sb-scrollbar"
    [style.--quick-column-count]="visibleQuickColumnCount()"
  >
    <header class="tournament-group__header">
      <div class="tournament-group__heading">
        <app-sport-icon
          class="tournament-group__sport-icon"
          [name]="sportIconName()"
          role="img"
          [attr.aria-label]="group().sportLabel"
          [attr.title]="group().sportLabel"
        ></app-sport-icon>
        <div class="tournament-group__titles">
          <span class="tournament-group__country">{{ group().country }}</span>
          <h2 class="tournament-group__name">{{ group().name }}</h2>
        </div>
      </div>

      @for (quickGroup of visibleQuickGroups(); track quickGroup.id) {
        <div
          class="tournament-group__market"
          [class.tournament-group__market--selectable]="mobile() && group().quickSelectionGroups.length > 1"
          [style.--quick-group-column-count]="quickGroup.headerLabels.length"
          [style.grid-column]="'span ' + quickGroup.headerLabels.length"
        >
          @if (mobile() && group().quickSelectionGroups.length > 1) {
            <select
              class="tournament-group__market-select"
              [attr.aria-label]="'tournament.chooseMarket' | translate"
              (change)="selectQuickGroup($event)"
            >
              @for (market of group().quickSelectionGroups; track market.id) {
                <option
                  class="tournament-group__market-option"
                  [value]="market.id"
                  [selected]="market.id === quickGroup.id"
                >{{ market.label }}</option>
              }
            </select>
          }

          <div class="tournament-group__market-labels" aria-hidden="true">
            @for (label of quickGroup.headerLabels; track $index) {
              <span class="tournament-group__market-label">{{ hideQuickHeaderLabels() ? '' : label }}</span>
            }
          </div>
        </div>
      }

      <button
        type="button"
        class="tournament-group__toggle"
        [attr.aria-expanded]="group().expanded"
        [attr.aria-controls]="'tournament-content-' + group().id"
        [attr.aria-label]="((group().expanded ? 'tournament.collapse' : 'tournament.expand') | translate)
          + ', ' + displayedMatchCount() + ' ' + ('tournament.matches' | translate)"
        (click)="toggleExpanded.emit(group().id)"
      >
        <span
          class="material-symbols-outlined tournament-group__toggle-icon"
          aria-hidden="true"
          [class.tournament-group__toggle-icon--expanded]="group().expanded"
        >
          expand_more
        </span>
      </button>
    </header>

    <div
      [id]="'tournament-content-' + group().id"
      class="tournament-group__content"
      [class.tournament-group__content--collapsed]="!group().expanded"
      [attr.aria-hidden]="!group().expanded"
      [attr.inert]="group().expanded ? null : ''"
    >
      <div class="tournament-group__content-inner">
        @for (match of group().matches; track match.id) {
          <app-match-preview
            [match]="match"
            [quickGroupIds]="visibleQuickGroupIds()"
            (selectionToggle)="selectionToggle.emit($event)"
            (openDetail)="openMatchDetail.emit($event)"
          ></app-match-preview>
        }
      </div>
    </div>
  </div>
</section>
